export default __webpack_public_path__ + "static/media/section4-right.2af13bac.png";